import React from "react";
import "./ConfirmDialog.scss";

export function ConfirmDialog({ open, title, message, onCancel, onConfirm, confirmLabel, cancelLabel, confirmDanger }) {
  if (!open) return null;
  return (
    <div className="cd-backdrop" onClick={onCancel}>
      <div className="cd-modal" onClick={(e) => e.stopPropagation()}>
        <p className="cd-title">{title || "Confirmar"}</p>
        {message && <p className="cd-message">{message}</p>}
        <div className="cd-actions">
          <button className={`cd-confirm${confirmDanger ? " cd-confirm--danger" : ""}`} onClick={onConfirm}>
            {confirmLabel || "Aceptar"}
          </button>
          <button className="cd-cancel" onClick={onCancel}>
            {cancelLabel || "Cancelar"}
          </button>
        </div>
      </div>
    </div>
  );
}
